/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, date: NonNullable<unknown>, store: NonNullable<unknown> }} Win_Back_Plan_DescriptionInputs */

const en_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your current ${i?.plan} expires on ${i?.date}. After you tap Renew Plus, ${i?.store} will show detailed plan information. You can cancel your subscription anytime in ${i?.store}.`)
};

const ar_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تنتهي خطتك الحالية ${i?.plan} في ${i?.date}. بعد الضغط على «جدّد اشتراك Plus»، سيعرض ${i?.store} تفاصيل الخطة. يمكنك إلغاء اشتراكك في أي وقت في ${i?.store}.`)
};

const de_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein aktuelles Abo (${i?.plan}) läuft am ${i?.date} ab. Wenn du auf „Plus verlängern“ tippst, zeigt ${i?.store} dir die Einzelheiten zum Abo an. Du kannst dein Abo jederzeit in ${i?.store} kündigen.`)
};

const es_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu plan actual (${i?.plan}) vence el ${i?.date}. Al tocar «Renovar Plus», ${i?.store} mostrará la información detallada del plan. Puedes cancelar tu suscripción en cualquier momento en ${i?.store}.`)
};

const fr_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ton abonnement actuel (${i?.plan}) expire le ${i?.date}. Après avoir appuyé sur « Renouveler Plus », tu verras les détails du plan dans ${i?.store}. Tu peux annuler ton abonnement à tout moment dans ${i?.store}.`)
};

const it_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo piano attuale (${i?.plan}) scade il ${i?.date}. Dopo aver toccato «Rinnova Plus», ${i?.store} mostrerà i dettagli del piano. Puoi annullare l’abbonamento in qualsiasi momento in ${i?.store}.`)
};

const ja_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`現在の${i?.plan}は${i?.date}に期限を迎えます。「Plusを更新」をタップすると、${i?.store}にプランの詳細情報が表示されます。サブスクリプションは${i?.store}でいつでも解約できます。`)
};

const ko_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`현재 ${i?.plan} 플랜은 ${i?.date}에 만료돼요. 「Plus 갱신」을 누르면 ${i?.store}에서 자세한 플랜 정보를 확인할 수 있어요. ${i?.store}에서 언제든 구독을 취소할 수 있어요.`)
};

const pt_br_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu plano atual ${i?.plan} termina em ${i?.date}. Ao tocar em “Renovar o Plus”, você verá os detalhes do plano na loja ${i?.store}. Você pode cancelar sua assinatura quando quiser na loja ${i?.store}.`)
};

const ru_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Твой текущий план ${i?.plan} истекает ${i?.date}. После нажатия «Продлить Plus» в ${i?.store} появится подробная информация о плане. Ты можешь отменить подписку в любое время в ${i?.store}.`)
};

const th_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`แผน ${i?.plan} ปัจจุบันของคุณจะหมดอายุในวันที่ ${i?.date} เมื่อแตะ “ต่ออายุ Plus” ${i?.store} จะแสดงข้อมูลแผนโดยละเอียด คุณยกเลิกการสมัครสมาชิกได้ทุกเมื่อใน ${i?.store}`)
};

const tr_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mevcut ${i?.plan} planın ${i?.date} tarihinde sona eriyor. “Plus'ı yenile” düğmesine dokunduğunda ${i?.store} ayrıntılı plan bilgilerini gösterecek. Aboneliğini istediğin zaman ${i?.store} üzerinden iptal edebilirsin.`)
};

const zh_cn_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`当前${i?.plan}至${i?.date}到期。点击「续订 Plus」后，${i?.store} 会显示详细方案信息。你可随时在 ${i?.store} 取消订阅。`)
};

const zh_tw_win_back_plan_description = /** @type {(inputs: Win_Back_Plan_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`當前${i?.plan}至${i?.date}到期。點選「續訂 Plus」後，${i?.store} 會顯示詳細方案資訊。你可隨時在 ${i?.store} 取消訂閱。`)
};

/**
* | output |
* | --- |
* | "Your current {plan} expires on {date}. After you tap Renew Plus, {store} will show detailed plan information. You can cancel your subscription anytime in {st..." |
*
* @param {Win_Back_Plan_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_plan_description = /** @type {((inputs: Win_Back_Plan_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Plan_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_plan_description(inputs)
	if (locale === "ar") return ar_win_back_plan_description(inputs)
	if (locale === "de") return de_win_back_plan_description(inputs)
	if (locale === "es") return es_win_back_plan_description(inputs)
	if (locale === "fr") return fr_win_back_plan_description(inputs)
	if (locale === "it") return it_win_back_plan_description(inputs)
	if (locale === "ja") return ja_win_back_plan_description(inputs)
	if (locale === "ko") return ko_win_back_plan_description(inputs)
	if (locale === "pt_br") return pt_br_win_back_plan_description(inputs)
	if (locale === "ru") return ru_win_back_plan_description(inputs)
	if (locale === "th") return th_win_back_plan_description(inputs)
	if (locale === "tr") return tr_win_back_plan_description(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_plan_description(inputs)
	return zh_tw_win_back_plan_description(inputs)
});